/* eslint-disable max-len */
var ICON_UI_CLOSE = {
  v2: true,
  "default": 'M0.75 23.249L23.25 0.748993M23.25 23.249L0.75 0.748993',
  globetrotter: 'M1.875 1.875L22.125 22.125M22.125 1.875L1.875 22.125'
};

export { ICON_UI_CLOSE };
//# sourceMappingURL=ICON_UI_CLOSE.js.map
